<template>
  <van-dialog v-model="show" :show-confirm-button="false" get-container="#app">
    <div class="modal-index-warp" @click.stop>
      <div class="modal-index-header">
        <div class="modal-index-name">基础信息</div>
        <div class="modal-index-info">
          <p>预警名称：{{warningDeatils.warningName || formData.warningName}}</p>
          <p>预警状态：待处理</p>
          <p>
            预警级别：
            <span
              style="color:red;"
            >{{warningDeatils.warningLevel || formData.warningLevel}}级预警</span>
          </p>
          <p>超时时间：{{warningDeatils.morethanTime || formData.morethanTime}}</p>
          <p
            v-show="warningDeatils.warningLevel ==1 || formData.warningLevel==1 "
          >分钟距离升级二级预警时间：{{warningDeatils.lastTime || formData.lastTime}}</p>
        </div>
        <div class="modal-index-name" v-show="jumpDetals">
          处理方式
          <span class="modal-index-span" @click="showSelectFun">
            {{selects.name}}
            <van-icon name="arrow-down" />
          </span>
          <van-action-sheet
            v-model="showSelect"
            :actions="actions"
            cancel-text="取消"
            @select="onSelect"
            close-on-click-action
            get-container="#app"
          />
        </div>
        <div class="modal-index-name" @click="showToastFun" v-if="selects.key==1">
          处理意见
          <img src="@/assets/wanning/header.png" />
        </div>
        <div class="modal-index-input" v-if="selects.key==1">
          <van-field v-model="hour" type="digit" placeholder="时" maxlength="2" />
          <van-field v-model="minute" type="digit" placeholder="分" maxlength="2" />
          <span>后再次提醒</span>
        </div>
        <div class="modal-index-text" v-if="selects.key==1">
          <van-field
            v-model="message"
            rows="3"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入处理结果"
          />
        </div>
      </div>
      <div class="modal-index-footer van-hairline--top">
        <van-button class="left_btn" @click="beforClose(false)">取消</van-button>
        <van-button class="right_btn" @click="beforSubmit" v-if="selects.key==1">确定</van-button>
        <van-button
          class="right_btn"
          @click="onSubmit('after')"
          v-if="(formData.businessType==2 || warningDeatils.businessType==2) && selects.key==2"
        >处理售后</van-button>
        <van-button
          class="right_btn"
          @click="onSubmit('order')"
          v-if="(formData.businessType==1 || warningDeatils.businessType==1) && selects.key==2"
        >立即发货</van-button>
      </div>
    </div>
  </van-dialog>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      hour: "",
      showSelect: false,
      minute: "",
      message: "",
      formData: {},
      selects: { name: "延后处理", key: 1 },
      actions: [
        { name: "延后处理", key: 1 },
        { name: "立即处理", key: 2 }
      ],
    };
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    warningId: {
      default: 0,
      type: Number,
    },
    jumpDetals:{
      default:false,
      type:Boolean
    },
    warningDeatils: {
      default: function () {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    beforClose(item) {
      this.$emit("closeModalFun", item);
    },
    beforSubmit() {
      this.http({
        url: "order/manage/warning/app/solveWarning",
        method: "post",
        parmes: {
          id: this.warningDeatils.id || this.formData.id,
          remindHours: this.hour || 0,
          remindMinutes: this.minute || 0,
          toast: this.message,
        },
      }).then((rps) => {
        if (rps.code == 200) {
          this.beforClose(true);
        }
      });
    },
    showToastFun() {
      this.$toast(
        "跟进处理选择再次提醒时间，设置对应时间，将在时间到期时，再次提醒，进入待处理列表；"
      );
    },
    showSelectFun(){
      if(this.jumpDetals){
        this.showSelect=!this.showSelect
      }
      
    },
    onSelect(item) {
      this.selects = item;
    },
    onSubmit(t) {
      if (this.warningDeatils.jump || this.jumpDetals) {
        if (t == "after") {
          this.jumpAfterDeatils();
        } else if (t == "order") {
          this.jumpsubOrderDeatils();
        }
      }
    },
    // 售后详情
    jumpAfterDeatils() {
      let businessId = this.formData.businessId ? this.formData.businessId : this.warningDeatils.businessId
      if (businessId) {
        this.beforClose(false);
        utils.jumpToNewPage({
          url:
            window.location.origin +
            "/h5user/beeafterorderDetail?afterId=" +businessId,
          noTitle: "0",
        });
      }
    },
    // 订单详情
    jumpsubOrderDeatils() {
      let businessId = this.formData.businessId ? this.formData.businessId : this.warningDeatils.businessId
      if (businessId) {
        this.beforClose(false);
        utils.jumpToNewPage({
          url:
            window.location.origin +
            "/h5user/beesOrderDetail?subId=" +businessId,
          noTitle: "0",
        });
      }
    },
    init(){
      if(this.jumpDetals){
        this.selects= { name: "立即处理", key: 2 };
      }
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.modal-index-header {
  padding: 30px;
  .modal-index-name {
    font-size: 28px;
    padding-bottom: 20px;
    color: #333;
    display: flex;
    align-items: center;
    img {
      width: 44px;
      height: 44px;
    }
    .modal-index-span {
      margin-left: 24px;
      border: 1px solid #dddddd;
      color: #999;
      text-align: center;
      padding: 15px 20px;
      vertical-align: middle;
    }
  }
  .modal-index-input {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #333;
    justify-content: flex-start;
    padding-top: 20px;
    span {
      width: 120px;
    }
    .van-cell {
      width: 144px;
      padding: 5px;
      margin-right: 15px;
      border: 1px solid #f2f2f2;
    }
  }
  .modal-index-text {
    padding-top: 30px;
    .van-cell {
      padding: 15px;
      border: 1px solid #f2f2f2;
    }
  }
  .modal-index-info {
    font-size: 24px;
    color: #999;
    padding: 10px 0 30px 0;
    p {
      padding: 3px 0;
    }
  }
  .van-cell::after {
    border-bottom: 0;
  }
}
.modal-index-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left_btn {
    width: 50%;
    border-right: 1px solid #d8d8d8;
    color: #333333;
  }
  .right_btn {
    width: 50%;
    color: #f8a651;
  }
}
</style>